import axios from '../axios'

const getTeacherAvailableEventsApi = async () => {
    return await axios.get(`api/teacher-available-events`)
}

export default getTeacherAvailableEventsApi
